export const ARCHIVED_PROJECT_OPACITY = 0.5
